import React from 'react';
import { View } from 'react-native';
import Typography from 'src/components/Text/Text';
import { styles } from './QuoteCard.styles';
import { CardDetailsProps } from './QuoteCard.types';
import { useGenerateSignedUrlMutation } from '../api/quotesApi';

const QuoteCardDetails: React.FC<CardDetailsProps> = ({ details, isSelected }) => {
  const [generateSignedUrl] = useGenerateSignedUrlMutation();

  const detailItems = [
    { label: 'Quote Number', value: details.quoteNumber },
    { label: 'Effective Date', value: details.effectiveDate },
    { label: 'Expiration Date', value: details.expirationDate },
    { label: 'Base Premium', value: details.basePremium },
    { label: 'Taxes', value: details.taxes },
    { label: 'Fees', value: details.fees },
  ];

  const handleViewDocument = async () => {
    if (details.quotePdf) {
      try {
        const response = await generateSignedUrl({ fileName: details.quotePdf }).unwrap();
        if (response.signedUrl) {
          window.open(response.signedUrl, '_blank');
        }
      } catch (error) {
        console.error('Failed to generate signed URL:', error);
      }
    }
  };

  return (
    <View style={[styles.details, isSelected && styles.selectedDetailsSection]}>
      {detailItems.map((item, index) => (
        <View
          key={item.label}
          style={[styles.detailRow, index === detailItems.length - 1 && styles.noBorder]}>
          <Typography variant="title1" style={styles.label}>
            {item.label}
          </Typography>
          <Typography variant="title1">{item.value}</Typography>
        </View>
      ))}
      <View style={[styles.detailRow, styles.noBorder]}>
        <Typography variant="body1" style={styles.label}>
          Quote Document:
        </Typography>
        <Typography variant="body1" style={styles.link} onPress={handleViewDocument}>
          View Here
        </Typography>
      </View>
    </View>
  );
};

export default QuoteCardDetails;
